import React from "react";
import FinanceCategoryFormModal from "@features/admin/finance/category/components/FinanceCategoryFormModal";
import { FinanceCategory } from "@features/admin/finance/category/types/financeCategory";

const UpdateFinanceCategoryModal: React.FC<{
    show: boolean;
    onHide: () => void;
    category: FinanceCategory | null;
    onSuccess?: () => void | Promise<void>;
}> = ({ show, onHide, category, onSuccess }) => {
    if (!category) return null;
    return (
        <FinanceCategoryFormModal
            show={show}
            onHide={onHide}
            category={category}
            onSaved={onSuccess}
            testId="update-finance-category-modal"
        />
    );
};

export default UpdateFinanceCategoryModal;
